import Vue from 'vue'

import axios from 'axios'
import qs from 'qs'
import {common} from '../js/common.js'


/*将axios设置为全局的*/
// Vue.prototype.$axios = axios

let service = {
  /**
   * 获取接口对接的路径
   */
  getInterfaceUrl() {
    let host = window.location.host;

    switch (host) {
      case '192.168.10.42:8080':
      case 'localhost:8080':
      case '127.0.0.1:8080':
        return 'https://testecf.eflycloud.com/ecfTask/';

      case 'testmobile.eflycloud.com':
        return 'https://testecf.eflycloud.com/ecfTask/';

      case 'preonlinemobile.eflycloud.com':
        return 'https://pre-ecf.eflycloud.com/ecfTask/';

      case 'm.eflycloud.com':
      default:
        return 'https://ecf.eflycloud.com/ecfTask/';
    }
  },

  /**
   * 获取图片路径
   */
  getImgUrl() {
    let host = window.location.host;

    switch (host) {
      case '192.168.10.42:8080':
      case 'localhost:8080':
      case '127.0.0.1:8080':
        return 'https://testecf.eflycloud.com';

      case 'testmobile.eflycloud.com':
        return 'https://testecf.eflycloud.com';

      case 'preonlinemobile.eflycloud.com':
        return 'https://pre-ecf.eflycloud.com';

      case 'm.eflycloud.com':
      default:
        return 'https://ecf.eflycloud.com';
    }
  },
  /**
   * 获取游客的token
   */
  getToken(successFn, errorFn) {
    let url = 'accountCenter/CreateToken';
    let params = {
      userID: 'RJ_VISITOR',
      password: 'RJ_VISITOR'
    }
    this.interfaceUrl(url, params, '', successFn, errorFn);
  },
  /**
   * 整理对接接口的参数
   */
  arrangementPar(par, type) {
    // var params = new FormData();
    // if(!par){
    //     return params;
    // }
    // for(let key in par){
    //     if(!par[key] && par[key] !== 0){
    //     // if(par[key] === ''){
    //     }else{
    //         params.append(key,par[key]);
    //     }
    // }
    // if(type == 'all'){
    //     let __ecfToken = common.getCookies('__ecfToken');
    //     let userID = common.getCookies('userID');
    //     params.append('__ecfToken',__ecfToken);
    //     params.append('userID',userID);
    // }else if(type == 'token'){
    //     let __ecfToken = common.getCookies('__ecfToken')
    //     params.append('__ecfToken',__ecfToken);
    // }
    // return params;

    let params = {};
    if (!par) {
      return params;
    }
    for (let key in par) {
      if (!par[key] && par[key] !== 0) {

      } else {
        params[key] = par[key];
      }
    }
    if (type == 'all') {
      let __ecfToken = common.getCookies('__ecfToken');
      let userID = common.getCookies('userID');
      params['__ecfToken'] = __ecfToken;
      params['userID'] = userID;
    } else if (type == 'token') {
      let __ecfToken = common.getCookies('__ecfToken');
      params['__ecfToken'] = __ecfToken;
    }
    return params;
  },
  /**
   * 对接接口的函数
   * @param url 接口
   * @param par 参数对象
   * @param type [val='all'||'token']
   *        =['all'], token跟userID都需要
   *        =['token'], 只需要token
   * @param successFn 成功回调函数
   * @param errorFn 失败回调函数
   */
  interfaceUrl(url, par, type, successFn, errorFn) {
    // let interfaceUrl = this.getInterfaceUrl() + url;
    // let params = this.arrangementPar(par,type);
    // axios({
    //     method: 'POST',
    //     url: interfaceUrl,
    //     data: params,
    // })
    // .then((res)=>{
    //     successFn(res.data);
    // })
    // .catch((error)=>{
    //     let errorTips = error.response.data;
    //     if(!errorFn){
    //         common.ErrorMap(errorTips.errorType,errorTips.errorMsg);
    //     }else{
    //         errorFn(errorTips)
    //     }
    // })
    let interfaceUrl = this.getInterfaceUrl() + url;
    let params = this.arrangementPar(par, type);
    let qs = require('qs');
    axios({
      method: 'POST',
      url: interfaceUrl,
      headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'},
      data: qs.stringify(params, {indices: false})
    })
      .then((res) => {
        successFn(res.data);
      })
      .catch((error) => {
        let errorTips = error.response.data;
        if (!errorFn) {
          common.ErrorMap(errorTips.errorType, errorTips.errorMsg);
        } else {
          errorFn(errorTips)
        }
      })
  }
}

export {
  service
}



// WEBPACK FOOTER //
// ./src/common/service/service.js